//Libs
import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
//Componentes Material
import Grid from '@material-ui/core/Grid';
//Ícones
import PersonIcon from '@material-ui/icons/Person';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
//Relatórios
import RelatorioClientes from './relatorio/RelatorioClientes';
import RelatorioAvaliacoes from './relatorio/RelatorioAvaliacoes';
//Controllers
import PermissaoController from '../controllers/PermissaoController';

/**
 * Componente para exiber os relatórios e atalhos para o perfil Avaliador
 */
class DashboardAvaliador extends Component {
    constructor(props) {
        super(props);
        //Controllers
        this.permissaoController = new PermissaoController();
        //Estado inicial
        this.state = {
            carregando: true,
            visualizarDashboardEmpresa: false,
            cadastrarCliente: false,
            cadastrarQuestionario: false
        };
    }

    async componentDidMount() {
        //Consulta o perfil do usuário logado
        const visualizarDashboardEmpresa = await this.permissaoController.permiteVisualizarDashboardEmpresa();
        const cadastrarCliente = await this.permissaoController.permiteCadastrarCliente();
        const cadastrarQuestionario = await this.permissaoController.permiteCadastrarQuestionario();
        //Atualiza o status da página
        this.setState({ carregando: false, visualizarDashboardEmpresa, cadastrarCliente, cadastrarQuestionario });
    }

    render() {
        const { visualizarDashboardEmpresa, cadastrarCliente, cadastrarQuestionario } = this.state;

        return (
            <Fragment>
                <Grid container spacing={1} >
                    {
                        cadastrarCliente &&
                        <Grid item xs={12} sm="auto" md={4} >
                            <Button startIcon={<PersonIcon />} size="large" variant="contained" color="primary" component={Link} to="/cliente/add" style={{ width: '100%' }} >Adicionar formando</Button>
                        </Grid>
                    }
                    {
                        cadastrarQuestionario &&
                        <Grid item xs={12} sm="auto" md={4} >
                            <Button startIcon={<AssignmentIndIcon />} size="large" variant="contained" color="primary" component={Link} to="/questionario/add" style={{ width: '100%' }} >Adicionar questionário</Button>
                        </Grid>
                    }
                    <Grid item xs={12} sm="auto" md={4} >
                        <Button startIcon={<PlaylistAddCheckIcon />} size="large" variant="contained" color="primary" component={Link} to="/avaliacao/add" style={{ width: '100%' }} >Iniciar avaliacao</Button>
                    </Grid>
                </Grid>
                {
                    visualizarDashboardEmpresa &&
                    <Grid container spacing={1} >
                        <RelatorioClientes />
                        <RelatorioAvaliacoes />
                    </Grid>
                }
            </Fragment>
        );
    }
}

export default DashboardAvaliador;